import React from 'react';
import TeamComponent from '../TeamComponent';
import PartnersComponent from '../PartnersComponent';
import Footer from '../Footer';
import styles from './About.module.css';

/*
  About page. Dark hero with a serif statement, then the team grid and
  partner grid below on the editorial-paper background, then footer.
*/

const teamMembers = [
  { photoUrl: 'images/team/sstouli.png',   name: 'Dr Sami Stouli',     position: 'Director' },
  { photoUrl: 'images/team/sespinosa.png', name: 'Dr Silvia Espinosa', position: 'Policy Lead',       zoom: 1.1 },
  { photoUrl: 'images/team/ssokullu.png',  name: 'Dr Senay Sokullu',   position: 'Senior Economist', offsetY: 11 },
];

const partnersImgs = [
  'images/partners/logo_wb.png',
  'images/partners/logo_instiglio.png',
  'images/partners/logo_dep.png',
  'images/partners/logo_mar.png',
  'images/partners/logo_min.png',
  'images/partners/logo_plum.png',
  'images/partners/logo_pay.png',
  'images/partners/logo_une.png',
];

function About() {
  return (
    <div>
      <section className={styles['hero']}>
        <div className={styles['hero-inner']}>
          <h1 className={styles['hero-title']}>
            We work in <em>specialised, senior teams on challenging problems</em>{' '}
            <span className={styles['hero-sub']}>
              — close to policymakers and focused on delivering tailored
              policy solutions.
            </span>
          </h1>
        </div>
      </section>

      <TeamComponent members={teamMembers} />
      <PartnersComponent images={partnersImgs} />
      <Footer />
    </div>
  );
}

export default About;
